"use client";
import React, { useContext, useState } from "react";
import styles from "./styles.module.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import logo from "../../Assets/images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import {
  usePostAsyncHandler,
  useGetAsyncHandler,
} from "../../App/Helpers/AsyncHandler.js";
import AuthApi from "../../App/api/auth.apis.js";
import { useFormik } from "formik";
import { AdminLogin } from "../../Store/Slices/AdminSlice.js";
import { useDispatch } from "react-redux";
import { generateYupSchema } from "../../App/Helpers/ValidationSchema/validator.js";
import LoaderContext from "../loader/LoaderContext.js";

function LoginCard({meta}) {
  const { handleLoading } = useContext(LoaderContext);
  const [isPassword, setIsPassword] = useState(false);
  const [roleId, setRoleId] = useState(null);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  //   const { mutate, isLoading, isError, error, data } = usePostAsyncHandler(
  //   async (payload) => {
  //     const response = await AuthApi.login(payload)
  //     return response.data;
  //   }
  // );

  const initialValues = {
    email: "",
    password: "",
  };

  const { handleChange, values, handleSubmit, errors, handleBlur, touched } =
    useFormik({
      initialValues: initialValues,
      validationSchema: generateYupSchema(roleId!==null?initialValues:{email:''}),
      onSubmit: (value) => {
        // console.log(values);
        const payload = {
          emailOrPhone: values.email,
          password: values.password,
        };
        try {
          if (roleId!==null) {            
            payload.roleId=roleId
            dispatch(AdminLogin(payload));
          }
          else{
            checkEmail({email:payload.emailOrPhone})
          }
        } catch (err) {
          // console.log(err);
        }
      },
    });

  const handleForgetPassword = () => {
    navigate("/forget-password");
  };

  const checkEmail=async(payload)=>{
    handleLoading(true)
    try {
      const res=await AuthApi.checkEmail(payload)
      // console.log(res?.data?.data);  
      setRoleId(res?.data?.data)
    } catch (error) {
      // console.log(error);
      setRoleId(null)
      
    }
    handleLoading(false)
  }

  return (
    <div className={styles.container}>
      <div className={styles.loginHeader}>
        <p className={styles.heading}>Welcome to eDelivery Admin Panel</p>
      </div>
      <div className={styles.loginForm}>
        <Link className={styles.logo} to="#">
          <img src={logo} alt="logo" width="100px" height="100px"></img>
        </Link>
        <h4 className={styles.formH}>Login</h4>
        <form onSubmit={handleSubmit} className={styles.Loginform}>
          <div className={styles.inputWrapper}>
            <label className={styles.label} htmlFor="email">
              Username
            </label>
            {errors.email && touched.email ? (
              <p
                style={{ paddingLeft: "0", paddingBlock: ".875rem" }}
                className="ess-form-error"
              >
                {" "}
                {errors.email}{" "}
              </p>
            ) : null}
            <input
              className={styles.input}
              id="email"
              name="email"
              onChange={handleChange}
              onBlur={(e)=>{
                handleBlur(e)
                generateYupSchema(roleId!==null?initialValues:{email:''})
                .validate({email:e.target.value})
                .then((res)=>{
                  checkEmail({email:e.target.value})
                })
                .catch((e)=>{
                  setRoleId(null)
                })
              }}
              value={values.email}
              placeholder="Username"
              type="email"
              required={true}
             
            />
          </div>
        {roleId!==null?(<div className={styles.inputWrapper}>
            <label className={styles.label} htmlFor="Password">
              Password
            </label>
            {errors.password && touched.password ? (
              <p
                style={{ paddingLeft: "0", paddingBlock: ".875rem" }}
                className="ess-form-error"
              >
                {" "}
                {errors.password}{" "}
              </p>
            ) : null}
            <div style={{ position: "relative" }}>
              <input
                className={styles.input}
                id="password"
                name="password"
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Password"
                type={isPassword ? "text" : "password"}
              />
              {isPassword ? (
                <FaEye
                  onClick={() => setIsPassword(!isPassword)}
                  className={styles.passwordEye}
                />
              ) : (
                <FaEyeSlash
                  onClick={() => setIsPassword(!isPassword)}
                  className={styles.passwordEye}
                />
              )}
            </div>
          </div>):""}
          <div className={styles.buttonWrapper}>
            <p className={styles.label} onClick={handleForgetPassword}>
              Forgot Password?
            </p>
            <button className={styles.button}>{roleId!==null?'Login':'Next'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginCard;
